import { render, staticRenderFns } from "./plateform.vue?vue&type=template&id=4a7a97b8&scoped=true"
import script from "./plateform.vue?vue&type=script&lang=js"
export * from "./plateform.vue?vue&type=script&lang=js"
import style0 from "./plateform.vue?vue&type=style&index=0&id=4a7a97b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a97b8",
  null
  
)

export default component.exports